import { type RuleSet } from "styled-components";
import { type Mode, getThemeStyle } from "~/features/ui/get-theme-style";
type SubNavThemeStyle = {
  background: TwStyle | RuleSet<object>;
  border: TwStyle | RuleSet<object>;
  text: TwStyle | RuleSet<object>;
};

// The light sub-nav mirrors the main header's solid surface
// (see nav-hamburger / nav-additional-links solid variants).
const lightTheme: SubNavThemeStyle = {
  background: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))",
    "--tw-backdrop-blur": "blur(8px)",
    "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
  },
  border: {
    "> :not([hidden]) ~ :not([hidden])": {
      "borderColor": "rgb(0 7 4 / 0.1)"
    },
    "borderColor": "rgb(0 7 4 / 0.1)"
  },
  text: {
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  }
};
export function getSubNavThemeStyle(mode: Mode): SubNavThemeStyle {
  if (mode === "light") {
    return lightTheme;
  }
  const {
    background,
    border,
    text
  } = getThemeStyle({
    theme: "grey",
    mode
  });
  return {
    background,
    border,
    text
  };
}